export default {
  bind: function(el, { value }, vnode) {
    if (value === true) {
      //el.style.display = "none";
    }
  },
};
